import { IPurchaseOrderRepository } from "domain/contracts/purchase-order.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { PurchaseOrder } from "domain/entities/purchase-order";
import { PurchaseOrderInputFilter } from "domain/models/purchase-order-input-filter";
import { formatDate } from "presentation/utils/formatEndDate";

class PurchaseOrderRepository implements IPurchaseOrderRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/purchaseOrder/${id}`);
    return response.data;
  }

  async create(input: PurchaseOrder): Promise<Message<PurchaseOrder>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { ...input, endAt: endAt, startAt: startAt };

    const response = await httpClient.post(`/purchaseOrder`, { data: newInput });
    return response.data;
  }

  async update(input: PurchaseOrder): Promise<Message<boolean>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { ...input, endAt: endAt, startAt: startAt };

    const response = await httpClient.put(`/purchaseOrder/${input.id}`, {
      data: newInput,
    });
    return response.data;
  }

  async getAll(
    filter: PurchaseOrderInputFilter
  ): Promise<Message<PurchaseOrder[]>> {
    const response = await httpClient.get(`/purchaseOrder`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<PurchaseOrder>> {
    const response = await httpClient.get(`/purchaseOrder/${id}`);
    return response.data;
  }
}

export default new PurchaseOrderRepository();
